type Item = { value: string };

type TreeNode = {
  title: string;
  key: string;
  value: string;
  selectable?: boolean;
  checkable?: boolean;
  children?: TreeNode[];
};

const capitalize = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);
const getPrefix = (v: string) => v.split("_", 1)[0];

export const buildTreeData = (items: Item[]): TreeNode[] => {
  const values = items.map((i) => i.value);

  const { groupOrder, groups } = values.reduce(
    (acc, v) => {
      const prefix = getPrefix(v);
      if (!acc.groups[prefix]) {
        acc.groups[prefix] = [];
        acc.groupOrder.push(prefix);
      }
      acc.groups[prefix].push(v);
      return acc;
    },
    { groupOrder: [] as string[], groups: {} as Record<string, string[]> }
  );

  return groupOrder.map((prefix) => {
    const children = groups[prefix];

    return {
      title: capitalize(prefix),
      key: `group:${prefix}`,
      value: `group:${prefix}`,
      selectable: false,
      checkable: false,
      children: children.map((v) => ({
        title: v,
        key: v,
        value: v,
        selectable: true,
        checkable: true,
      })),
    };
  });
};
